import type { NamespaceSchema } from './types';

export const mediaSettings: NamespaceSchema = {
  namespace: 'media-settings',
  label: 'Media',
  description: 'Image storage + upload limits. S3 credentials live in env / Secrets Manager.',
  sections: [
    {
      label: 'Storage driver',
      description: 'S3 bucket / region / credentials live in env (S3_BUCKET, S3_REGION, S3_ACCESS_KEY_ID, S3_SECRET_ACCESS_KEY).',
      fields: [
        { kind: 'select', key: 'driver', label: 'Driver', default: 's3', options: [
          { value: 's3', label: 'S3 (production)' },
          { value: 'minio', label: 'MinIO (local dev)' },
          { value: 'local', label: 'Local filesystem' },
        ] },
        { kind: 'url', key: 'cdn_url', label: 'CDN base URL', placeholder: 'https://cdn.drivecars.ai', description: 'Public CDN host that fronts the S3 bucket. Operational, not secret.' },
      ],
    },
    {
      label: 'Upload limits',
      fields: [
        { kind: 'number', key: 'max_upload_mb', label: 'Max upload size (MB)', default: 10, min: 1, max: 100 },
        { kind: 'multiselect', key: 'allowed_mime', label: 'Allowed MIME types', default: ['image/jpeg', 'image/png', 'image/webp'], options: [
          { value: 'image/jpeg', label: 'JPEG' },
          { value: 'image/png', label: 'PNG' },
          { value: 'image/webp', label: 'WebP' },
          { value: 'image/avif', label: 'AVIF' },
          { value: 'image/svg+xml', label: 'SVG' },
        ] },
      ],
    },
    {
      label: 'Image processing',
      fields: [
        { kind: 'boolean', key: 'auto_optimize', label: 'Auto-optimise on upload', default: true, description: 'Sharp re-encode + resize variants (thumb / 600 / 1024).' },
        { kind: 'boolean', key: 'strip_exif', label: 'Strip EXIF metadata', default: true },
      ],
    },
  ],
};
